import React from 'react';
import { Skeleton } from 'antd';
import { CustomSkeleton } from './styles';

const SkeletonFilter = () => {
    return (
        <CustomSkeleton>
            <div className="item">
                <Skeleton.Button active />
                <Skeleton.Button active />
                <Skeleton.Button active />
            </div>
            <div className="item">
                <Skeleton.Button active />
                <Skeleton.Button active />
            </div>
            <div className="item">
                <Skeleton.Button active />
                <Skeleton.Button active />
                <Skeleton.Button active />
            </div>
        </CustomSkeleton>
    );
};

export default SkeletonFilter;